import { MyAsset, PriceList, Token } from '@jdiyield/interfaces'
import { LCDClient } from '@terra-money/terra.js'
import BigNumber from 'bignumber.js'
import { findToken } from '../utils'

type Props = {
  walletAddress: string
  tokens: Token[]
  priceList: PriceList
}

export const queryAssets = async ({ walletAddress, tokens, priceList }: Props): Promise<MyAsset[]> => {
  const terra = new LCDClient({
    URL: 'https://lcd.terra.dev',
    chainID: 'columbus-4'
  })
  const coins = await terra.bank.balance(walletAddress)

  const result = coins
    .map(({ denom, amount }) => {
      const token = findToken(tokens, denom)
      if (!token) return null
      const value = amount.toNumber() / 1e6
      const ratePriceUSD = priceList[token?.address]?.usd || 0
      return {
        currency: {
          address: token?.address || denom,
          name: token?.symbol || denom,
          symbol: token?.symbol || denom,
          decimals: token?.decimals || 6
        },
        logo: token?.logo ?? 'https://bscscan.com/images/main/empty-token.png',
        value: !isNaN(value) ? value : 0,
        valueUSD: ratePriceUSD * value,
        ratePriceUSD
      }
    })
    .filter((obj) => !!obj && obj.value >= 0.001)
  return result
}
